import styled from 'styled-components';
import { SIZE, FONTS, COLORS } from '@app/src/ui';

interface Props {
  color?: string;
}

const FONT_RESPONSIVE = '13px';

export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const DateWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const DateSelected = styled.div`
  height: 24px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  background-color: ${(props:Props) => props.color};
  align-items: center;
  margin: 3px 6px;

  span {
    font-family: ${FONTS.OPEN_SANS};
    font-size: ${FONT_RESPONSIVE};
    line-height: 16px;
    margin-right: 5px;
  }
`;

export const SubTitle = styled.span`
  display: block;
  font-family: ${FONTS.OPEN_SANS};
  font-size: ${FONT_RESPONSIVE};
  line-height: 16px;
  color: ${COLORS.BLACK};
  margin-bottom: 15px;
  font-weight: bold;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 23px;
  }
`;